import { HttpClient } from '@angular/common/http';
import { Component, Injector, OnInit } from '@angular/core';
import { CoreClass } from '@src/app/core/base/core.class';
import { ALL_SERVICES, COMMON_MODULES, IMAGES_URL, PLUS_MEMBERSHIP, ROUTES } from '@src/app/core/constants';
import { MembershipPlanModule } from '@src/app/core/shared/components/membership-plan/membership-plan.module';
import { MiniEnvBgContentComponent } from '@src/app/core/shared/components/mini-env/mini-env-bg-content/mini-env-bg-content.component';
import { MiniEnvContentBoxComponent } from '@src/app/core/shared/components/mini-env/mini-env-content-box/mini-env-content-box.component';
import { MiniEnvFaqsComponent } from '@src/app/core/shared/components/mini-env/mini-env-faqs/mini-env-faqs.component';
import { MiniEnvSubFooterComponent } from '@src/app/core/shared/components/mini-env/mini-env-sub-footer/mini-env-sub-footer.component';
import { MiniEnvTallInfoCardComponent } from '@src/app/core/shared/components/mini-env/mini-env-tall-info-card/mini-env-tall-info-card.component';
import { MiniEnvTestimonialsComponent } from '@src/app/core/shared/components/mini-env/mini-env-testimonials/mini-env-testimonials.component';
import { BannerOneModule } from '@src/app/core/shared/components/ui/banner/banner-one/banner-one.module';
import { MiniEnvBannerComponent } from '@src/app/core/shared/components/ui/banner/mini-env-banner/mini-env-banner.component';
import { CardboxOneModule } from '@src/app/core/shared/components/ui/cardbox/cardbox-one/cardbox-one.module';
import { MiniEnvInfoCardComponent } from '@src/app/core/shared/components/ui/cardbox/mini-env-info-card/mini-env-info-card.component';
import { HeadingBlockFullWidthModule } from '@src/app/core/shared/components/ui/heading-box/heading-block-fullwidth/heading-block-fullwidth.module';
import { HeadingBlockOneModule } from '@src/app/core/shared/components/ui/heading-box/heading-block-one/heading-block-one.module';
import { MiniEnvHeadingBlockComponent } from '@src/app/core/shared/components/ui/heading-box/mini-env-heading-block/mini-env-heading-block.component';
import { IconboxOneModule } from '@src/app/core/shared/components/ui/iconbox/iconbox-one/iconbox-one.module';
import { IconboxTwoModule } from '@src/app/core/shared/components/ui/iconbox/iconbox-two/iconbox-two.module';
import { ImageboxBulletScrollComponent } from '@src/app/core/shared/components/ui/imagebox/imagebox-bullet-scroll/imagebox-bullet-scroll.component';
import { ImageboxFullwidthModule } from '@src/app/core/shared/components/ui/imagebox/imagebox-fullwidth/imagebox-fullwidth.module';
import { ImageboxOneModule } from '@src/app/core/shared/components/ui/imagebox/imagebox-one/imagebox-one.module';
import { VideoPlayerComponent } from '@src/app/core/shared/components/video-player/video-player.component';
import * as parkerJson from '@src/assets/i18n/mini-env/parker-hospitality/en.json';
import { MiniEnvTabsComponent } from "@src/app/core/shared/components/mini-env/mini-env-tabs/mini-env-tabs.component";

@Component({
  selector: 'app-parker-hospitality',
  imports: [
    ...COMMON_MODULES,
    HeadingBlockOneModule,
    IconboxOneModule,
    IconboxTwoModule,
    HeadingBlockFullWidthModule,
    ImageboxOneModule,
    ImageboxFullwidthModule,
    CardboxOneModule,
    BannerOneModule,
    ImageboxBulletScrollComponent,
    MiniEnvHeadingBlockComponent,
    MiniEnvFaqsComponent,
    MiniEnvBannerComponent,
    MiniEnvSubFooterComponent,
    MembershipPlanModule,
    VideoPlayerComponent,
    MiniEnvContentBoxComponent,
    MiniEnvTestimonialsComponent,
    MiniEnvTallInfoCardComponent,
    MiniEnvBgContentComponent,
    MiniEnvTabsComponent
],
  templateUrl: './parker-hospitality.component.html',
  styleUrl: './parker-hospitality.component.scss'
})
export class ParkerHospitalityComponent extends CoreClass implements OnInit {

  IMAGES_URL: string = IMAGES_URL;
  faqList = parkerJson.FAQS.FAQ_LIST;
  imgSrc = 'assets/tenant-assets/mini-env/images/people-in-kitchen.png';
  bgClass = 'father-child-bg';
  services = ['concierge_healthcare', 'dental_services', 'exclusive_discount'];


  // public language: string = ""
  // style = 'font-size: 64px;line-height: 78px';
  constructor(
    injector: Injector,
    private httpClient: HttpClient
  ) {
    super(injector);
  }
  All_SERVICES_PATH: string = ALL_SERVICES;
  membershipPlanCode = 'WOW_PLUS_H2U_MEMBERSHIP,COMPREHENSIVE_CARE_H2U_MEMBERSHIP';
  benefits = [
    {
      id: '01',
      title: 'Flexibility',
      description: 'Manage your health with comprehensive in-person and virtual care options that fit your schedule and medical needs.',
      bgImage: 'd-shape'
    },
    {
      id: '02',
      title: 'Affordability',
      description: 'Free virtual services, and direct-pay for in-person care with exclusive discounts, so you pay less than with an insurance plan.',
      bgImage: 'circles'
    },
    {
      id: '03',
      title: 'Transparency',
      description: 'Know the total cost of care when you make an appointment, and pay at the time of service. Goodbye surprises & bills in the mail.',
      bgImage: 'm-shape'
    },
  ];

  faqs: any[] = [
  {
    question: 'What is the difference between WoW Plus & health insurance?',
    answer: 'WoW Plus provides steeply discounted access to medical providers... It is not insurance but a direct pay network...'
  },
  {
    question: 'Why do I need WoW Health?',
    answer: 'It provides affordable access to routine care and prescriptions...'
  }
];

bannerSlides: any[] = [
  {
    title: 'Comprehensive Care with WoW Health',
    subtitle: 'Every aspect of healthcare covered from virtual urgent care to dental care and labs.',
    buttonText: 'View Plans',
    bgImageUrl: 'assets/tenant-assets/mini-env/parker-hospitality/parker-hospitality-banner.png',    
    link: '/join',
    bannerClass: 'parker-hospitality-banner'
  },
];

  ngOnInit(): void {
    this.sharedService.removeNavbarLinks = false;
  }

  buttonAction() {
    const section = document.getElementById('membership-section');

    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  onSliderBtnAction() {
    this.buttonAction();
  }

  getStartedAction() {
    this.router.navigateByUrl(PLUS_MEMBERSHIP);
  }

}
